var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acknowledgement-text"},[_vm._v("\n    "+_vm._s(_vm._value)),(_vm.requiresSnipping && !_vm.showFull)?_c('a',{staticClass:"ml-1 more-link",attrs:{"href":"#"},on:{"click":_vm.loadFull}},[_vm._v("More")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }